import { omniAtom } from "src/utils/atoms";

const prefix = "merchflows/:merchflowId/stores/all";

export const merchflows_merchflowId_StoresAllHistoryAtom = omniAtom({
  prefix,
  key: "history",
  value: {} as { [merchflowId: number]: string },
});
